import { Component, OnInit } from '@angular/core';
import { CouponService } from '../../services/coupon.service';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { menurolesService } from '../../services/menuroles.service';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-add-subscription',
  templateUrl: './add-subscription.component.html',
  styleUrls: ['./add-subscription.component.scss']
})
export class AddSubscriptionComponent implements OnInit {

  public isPageEditable: boolean = false;
  private formSubmitAttempt: boolean;
  isSlide: boolean = false;
  coupons: Observable<any>;
  reports: any[];
  subscriptionList: any[];
  statusMessage: string = "Loading data please wait...";
  couponForm: FormGroup;
  HtmlSSO: string;
  html: any;
  constructor(private _couponService: CouponService,private _employeeService: EmployeeService, private fb: FormBuilder, config: NgbDatepickerConfig, private _menurolesService: menurolesService) {
    const currentDate = new Date();

    config.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
    config.maxDate = { year: 2099, month: 12, day: 31 };

    config.outsideDays = 'hidden';
    this.couponForm = fb.group({
      discountTypeId: ['',],
      couponCode: ['', [Validators.required]],
      description: ['', [Validators.required]],
      subscriptionAmount: ['', [Validators.required]],
      maxUsage: ['', [Validators.required]],
      validFrom: ['',[Validators.required]],
      validTill: ['', [Validators.required]],
      appliedForAll: ['']
    });
  }

  ngOnInit() {
    this.getAllSubscription();
    this.getAllCoupons();
    this.isPageEditable = this._menurolesService.getpageAcessbility()
  }

  getAllSubscription(){
    console.log('getAllSubscription1');
    this._employeeService.getAllSubscriptionList().subscribe((subscribeData: any)=>{
      console.log('getAllSubscription ', subscribeData);
      this.subscriptionList = subscribeData.response.subscriptionList;
      for(let index = 0;index<this.subscriptionList.length;index++){
        if(this.subscriptionList[index].validfrom != null){
          this.subscriptionList[index].validfrom = this.convertDateToFormat(this.subscriptionList[index].validfrom);
        }
        if(this.subscriptionList[index].validtill != null){
          this.subscriptionList[index].validtill = this.convertDateToFormat(this.subscriptionList[index].validtill);
        }
      }
    })
  }

  convertDateToFormat(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [mnth, day , date.getFullYear()].join("-");
  }


  getAllCoupons() {
    this._couponService.getcoupans()
      .subscribe(
        (couponData) => {
          if (couponData.response == null) {
            this.coupons = null
          }
          else {
            this.coupons = couponData.response.couponList

          }
          console.log(this.coupons);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  reset() {
    this.couponForm.reset();
    this.formSubmitAttempt = false;
  }
  savecoupon(couponForm: FormGroup) {
    this.formSubmitAttempt = true;
    var date = new Date();
    // var todaysdate =date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    var todaysdate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    this.couponForm.value.token = loginUser.token;
    let formateddate1 = couponForm.value.validFrom;
    let formateddate2 = couponForm.value.validTill;
    couponForm.value.validFrom = todaysdate;
    couponForm.value.isusedforall = (couponForm.value.appliedForAll == null || couponForm.value.appliedForAll == '') ? true : couponForm.value.appliedForAll;
    couponForm.value.validTill = new Date(formateddate2.year + '-' + formateddate2.month + '-' + formateddate2.day)
    couponForm.value.discountTypeId = (couponForm.value.discountTypeId == null || couponForm.value.discountTypeId == '') ? 2 : couponForm.value.discountTypeId;
    if (couponForm.invalid) {
      return;
    }
    else {
      this._couponService.saveCoupon(this.couponForm.value).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Coupons records save Sucessfully")
            this.getAllCoupons();
            this.couponForm.reset();
            this.formSubmitAttempt = false;
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }

  publishCoupon(coupon: any) {
    var isVerified = coupon.isPublished == false ? true : false;
    coupon.isCouponsActive = isVerified;
    let confimationMessage = isVerified == true ? "Are you sure want to Publish " : "Are you sure Not want to publish  ";
    if (confirm(confimationMessage)) {
      this._couponService.publishCoupon(coupon).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")
            this.getAllCoupons();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
    else {
      this.getAllCoupons();
    }
  }

  deleteCoupon(coupon: any) {
    let confimationMessage = "Are you sure want to Delete " + coupon.couponsCode;
    if (confirm(confimationMessage)) {
      this._couponService.deleteCoupon(coupon).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")
            this.getAllCoupons();
          }
          else {
            if (data.returnCode == 2) {
              alert("This Coupon is already in use,you can't delete")
              this.getAllCoupons();
            }
          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
    else {
      this.getAllCoupons();
    }

  }


  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }
  }


  toUTF8Array(str) {
    var utf8 = [];
    for (var i = 0; i < str.length; i++) {
      var charcode = str.charCodeAt(i);
      if (charcode < 0x80) utf8.push(charcode);
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6),
          0x80 | (charcode & 0x3f));
      }
      else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
      // surrogate pair
      else {
        i++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + (((charcode & 0x3ff) << 10)
          | (str.charCodeAt(i) & 0x3ff));
        utf8.push(0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
    }
    return utf8;
  }

  //   base64ToArrayBuffer(base64) {
  //     var binary_string = window.atob(base64);
  //     var len = binary_string.length;
  //     var bytes = new Uint8Array(len);
  //     for (var i = 0; i < len; i++) {
  //         bytes[i] = binary_string.charCodeAt(i);
  //     }
  //     return bytes.buffer;
  // }
}




// WEBPACK FOOTER //
// ./src/app/admin/add-subscription/add-subscription.component.ts